import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AuthorComposerView } from "./AuthorComposerView";
import { AuthorComposerViewStore } from "../../store/AuthorComposerViewStore";
import { useStore } from "../../../../hooks";

export const AuthorComposerViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/authorComposer/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AuthorComposerViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "personalInformation",
              label:
                rootStore.langStore.groupAuthorComposerPersonalInformationLabel,
            },
            {
              id: "address",
              label: rootStore.langStore.groupAuthorComposerAddressLabel,
            },
            {
              id: "professionalInformation",
              label:
                rootStore.langStore
                  .groupAuthorComposerProfessionalInformationLabel,
            },
            {
              id: "systemDates",
              label: rootStore.langStore.groupAuthorComposerSystemDatesLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AuthorComposerView authorComposerViewStore={store} />
      </PageLayout>
    </div>
  );
});
